import React from 'react';
import { OwnerProfile } from '../../../types/owner';
import { Avatar, Divider, Paper, Stack, Typography } from '@mui/material';

const OwnerProfileStats = ({ owner }: { owner: OwnerProfile }) => {
    return (
        <section aria-label='Host stats'>
            <Paper
                elevation={0}
                sx={{
                    bgcolor: 'custom.cardActionBackground',
                    p: 4,
                    display: 'flex',
                    alignItems: { xs: 'flex-start', md: 'center' },
                    gap: 4,
                }}
            >
                <Avatar
                    sx={{ width: 125, height: 125 }}
                    src={owner.logo?.src}
                    alt={`${owner.name} logo`}
                />
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    spacing={4}
                    divider={
                        <Divider
                            component='div'
                            aria-orientation='vertical'
                            orientation='vertical'
                            flexItem
                        />
                    }
                >
                    <div>
                        <Typography sx={{ fontWeight: 'bold' }}>
                            {owner.averageRating || <>&mdash;</>} stars
                        </Typography>
                        <Typography variant='body2'>Popularity</Typography>
                    </div>
                    <div>
                        <Typography sx={{ fontWeight: 'bold' }}>
                            {owner.suburb}, {owner.state}
                        </Typography>
                        <Typography variant='body2'>Location</Typography>
                    </div>
                    <div>
                        <Typography sx={{ fontWeight: 'bold' }}>
                            {new Date(owner.createdAt).getFullYear()}
                        </Typography>
                        <Typography variant='body2'>Hosting since</Typography>
                    </div>
                </Stack>
            </Paper>
        </section>
    );
};

export default OwnerProfileStats;
